// =========================================================================================@@
// Last Updated Date: Jan 21, 2023
// Last Updated By: Steven Yuen
// Status Level: 1
// ===========================================================================================

import React, { useEffect } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { useGlobalState } from 'src/sites/state'

const MultiPageNavPane = ({ children }) => {
   const { theme, setTheme } = useGlobalState()
   const isFixedWidthLayout = theme.layoutContentFillMode === 'fixed'
   const menuWidth = '100%[a-b] 32vw[c] 300px[d] 300px[e-f]'

   useEffect(() => {
      setTheme({ ...theme, showColumnView: true })

      return (() => {
         setTheme({ ...theme, showColumnView: false })
      })
   }, [])

   return (
      <View
         float="left"
         height="100%"
         width="100%[a-b]"
         paddingLeft={isFixedWidthLayout
            ? theme.tmpViewportPadding
            : `
               ${theme.tmpViewportPaddingA}[a]
               ${theme.tmpViewportPaddingB}[b]
               ${theme.tmpViewportPaddingC}[c]
               0px[d-f]
               `
         }
         scroll="on">
         <View
            position="relative"
            float="left"
            width={menuWidth}
            height="100%"
            paddingLeft={!isFixedWidthLayout && '20px[d-f]'}
            backgroundColor="var(--bodyBlockBackgroundColor)"
            borderRight="1px solid var(--columnLineColor)">
            {children}
         </View>
      </View>
   )
}

MultiPageNavPane.propTypes = {
   children: PropTypes.node.isRequired
}

export default MultiPageNavPane
